import { AfterViewInit, Component, ElementRef, OnDestroy, PLATFORM_ID, ViewChild, inject, input, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { LandingText } from '../landing.types';
import { LandingGlow } from './landing-glow.component';
import { RevealOnScrollDirective } from './reveal-on-scroll.directive';

@Component({
    selector: 'app-landing-work',
    standalone: true,
    imports: [LandingGlow, RevealOnScrollDirective],
    templateUrl: './landing-work.component.html',
    styleUrl: './landing-work.component.scss'
})
export class LandingWork implements AfterViewInit, OnDestroy {
    readonly text = input.required<LandingText>();

    // One icon per card, in the same order as workCards (intake, process, deliver) — mirrors the pipeline mock columns below.
    readonly workIcons = ['pi-inbox', 'pi-spin pi-cog', 'pi-send'];

    // Which work card is hovered, so the matching pipeline mock column lights up (0 = intake, 1 = process, 2 = deliver).
    readonly hoveredStage = signal<number | null>(null);

    // :host is `display: contents` (no box of its own), so we must observe the section, not the host element.
    @ViewChild('workSection', { static: true }) private readonly sectionRef!: ElementRef<HTMLElement>;
    private readonly platformId = inject(PLATFORM_ID);
    private observer?: IntersectionObserver;

    // Drives whether the pipeline mock's CSS animations run; kept false until the section nears the viewport.
    readonly isVisible = signal(false);

    ngAfterViewInit(): void {
        if (!isPlatformBrowser(this.platformId) || typeof IntersectionObserver === 'undefined') {
            this.isVisible.set(true);
            return;
        }

        this.observer = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    this.isVisible.set(entry.isIntersecting);
                }
            },
            { rootMargin: '200px 0px' }
        );
        this.observer.observe(this.sectionRef.nativeElement);
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }
}
